
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.211","height":"12.43"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 231","transform":"translate(-.054)","fill":"none","stroke":"#595959","stroke-miterlimit":"10"}},[_c('path',{attrs:{"data-name":"Path 511","d":"M19.669 6.216c-2.261 3.49-5.681 5.714-9.51 5.714S2.911 9.706.65 6.216C2.909 2.726 6.331.5 10.16.5s7.25 2.226 9.509 5.716z"}}),_c('path',{attrs:{"data-name":"Path 512","d":"M19.669 6.216c-2.261 3.49-5.681 5.714-9.51 5.714S2.911 9.706.65 6.216C2.909 2.726 6.331.5 10.16.5s7.25 2.226 9.509 5.716z"}}),_c('circle',{attrs:{"data-name":"Ellipse 24","cx":"3.709","cy":"3.709","r":"3.709","transform":"translate(6.451 2.505)"}})])])
          )
        }
      }
    